import { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, TextField, DialogTitle,
  Box, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import SellIcon from '@mui/icons-material/Sell';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, CancelButton, SubmitButton } from "../styled/CustomButtons";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ButtonSpinnerBlue } from "../styled/CustomSpinners";

export default function  CreateSkusDialog({ addSnackbar }) {
    const [open, setOpen] = useState(false);
    const [loadingCreateSheet, setLoadingCreateSheet] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [spreadsheetUrl, setSpreadsheetUrl] = useState("");
    const [purchasingCompany, setPurchasingCompany] = useState("");

    const handleOpen = () => {
        setOpen(true);
        setSpreadsheetUrl("");
        setPurchasingCompany("");
    };

    const handleClose = () => {
        if (!loadingCreateSheet && !loadingSubmit) {
            setOpen(false);
        }
    };

    const validateUrlAndExtractId = () => {
        let spreadsheetId;
        if (!spreadsheetUrl.includes('/')) {
            spreadsheetId = spreadsheetUrl;
        } else {
            const splitUrl = spreadsheetUrl.split('/');
            const dIndex = splitUrl.indexOf('d');
            if (dIndex === -1 || dIndex + 1 >= splitUrl.length) {
                throw new Error('Invalid Google Sheets URL.');
            }
            spreadsheetId = splitUrl[dIndex + 1];
        }
        if (spreadsheetId.replace(' ', '').length !== 44) {
            throw new Error('Invalid Google Sheets ID.');
        }
        return spreadsheetId;
    };

    const handlePurchasingCompanyChange = (e) => {
        const value = e.target.value;
        setPurchasingCompany(value);
    }

    const createProductsSheet = async () => {
        setLoadingCreateSheet(true);
        try {
            const response = await sendRequest('create-products-sheet');
            const newSpreadsheetUrl = `https://docs.google.com/spreadsheets/d/${response}`;
            window.open(newSpreadsheetUrl, '_blank');
            setLoadingCreateSheet(false);
            handleClose();
        } catch (error) {
            addSnackbar(error.message, false);
            setLoadingCreateSheet(false);
        }
    };

    const submitProductsSheet = async () => {
        setLoadingSubmit(true);
        try {
            if (!purchasingCompany) {
                throw new Error('Purchasing company is required.');
            }
            const spreadsheetId = validateUrlAndExtractId();
            const response = await sendRequest(
                'create-skus-from-sheet',
                { spreadsheet_id: spreadsheetId, purchasing_company: purchasingCompany },
                'POST',
            );
            addSnackbar(response.message);
            setLoadingSubmit(false);
            handleClose();
        } catch (error) {
            addSnackbar(error.message, false);
            setLoadingSubmit(false);
        }
    };

    return (
        <>
            <MenuButtonIcon
                isIcon={true}
                title={"Create SKUs"}
                icon={SellIcon}
                iconProps={{ sx: { fontSize: 50 }}}
                onClick={handleOpen}
                variant=''
                sx={{ color: 'primary.main', padding: 0 }}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                disableEscapeKeyDown={loadingCreateSheet || loadingSubmit}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        submitProductsSheet();
                    },
                    autoComplete: 'off',
                }}
            >
                <DialogTitle sx={{ py: 0, px: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        <h4>Create SKUs</h4>
                        <Box sx={{ flexGrow: 1 }} />
                        <MenuButtonIcon
                            isIcon={true}
                            title={"Create new Sheet"}
                            icon={loadingCreateSheet ? ButtonSpinnerBlue : AddCircleIcon}
                            iconProps={{ sx: { fontSize: 40 }}}
                            onClick={createProductsSheet}
                            variant=''
                            sx={{ color: 'primary.main', p: 0, mt: 2 }}
                        />
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ px: 2, py: 0 }}>
                    <DialogContentText>
                        Please enter the Spreadsheet URL or ID of the products sheet to create SKUs.
                    </DialogContentText>

                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="spreadsheetUrl"
                        name='spreadsheetUrl'
                        label="Google Sheets URL or ID"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={spreadsheetUrl}
                        onChange={(e) => setSpreadsheetUrl(e.target.value)}
                        disabled={loadingCreateSheet || loadingSubmit}
                    />
                    <FormControl fullWidth variant="standard" margin="dense" required>
                        <InputLabel id="company-label">Company</InputLabel>
                        <Select
                        labelId="company-label"
                        id="company"
                        value={purchasingCompany}
                        onChange={handlePurchasingCompanyChange}
                        label="Company"
                        >
                            <MenuItem value="LUX">LUX</MenuItem>
                            <MenuItem value="ESSX">ESSX</MenuItem>
                        </Select>
                    </FormControl>

                    <DialogActions sx={{ marginTop: 2, px: 0 }}>
                        <CancelButton onClick={handleClose} disabled={loadingCreateSheet || loadingSubmit}>Cancel</CancelButton>
                        <SubmitButton
                            type="submit"
                            showSpinner={loadingSubmit}
                            text={"Submit Sheet"}
                            disabled={(spreadsheetUrl === '') || (purchasingCompany === '') || loadingSubmit || loadingCreateSheet}
                        />
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    )
};